/* eslint-disable @typescript-eslint/camelcase */

import * as Rox from "rox-browser";
import { FcsFlag } from "../unleash";

export const FlagsBulkDownloadData = {
  bulk_action_download_data_permission_list: new FcsFlag.Flag(false),
  bulk_action_download_data_role: new FcsFlag.Flag(false),
  bulk_action_download_data_ecargo_commody: new FcsFlag.Flag(false),
  bulk_action_download_data_commody: new FcsFlag.Flag(false),
  bulk_action_download_data_location_country: new FcsFlag.Flag(false),
  bulk_action_download_data_location_city: new FcsFlag.Flag(false),
  bulk_action_download_data_location_district: new FcsFlag.Flag(false),
  bulk_action_download_data_vendor: new FcsFlag.Flag(false),
  bulk_action_download_data_transport_vendor: new FcsFlag.Flag(false),
  bulk_action_download_data_leg: new FcsFlag.Flag(false),
  bulk_action_download_data_leg_route: new FcsFlag.Flag(false),
  bulk_action_download_data_routeleg: new FcsFlag.Flag(false),
  bulk_action_download_data_sla_district: new FcsFlag.Flag(false),
  bulk_action_download_data_sla_city: new FcsFlag.Flag(false),
  bulk_action_download_data_cargo_config: new FcsFlag.Flag(false),
  bulk_action_download_data_awb_reserve: new FcsFlag.Flag(false),
  bulk_action_download_data_region: new FcsFlag.Flag(false),
  bulk_action_download_data_region_city: new FcsFlag.Flag(false),
  bulk_action_download_data_kargo_grouping: new FcsFlag.Flag(false),
  bulk_action_download_data_reason_hal_cd: new FcsFlag.Flag(false),

};

export function initFlagsBulkDownloadData() {
  // register flags with namespaces for better grouping
  FcsFlag.register("FlagsBulkDownloadData", FlagsBulkDownloadData);
}
